import { createContext, useContext, useEffect, useState } from "react";

import { jsonMunicipios } from "@/services/flowQuote";

import { MunicipioJson } from "@/types/FlowQuote";
import { ReactNode } from "react";

const CACHE_KEY = "municipios_cache";
const CACHE_TTL_MS = 24 * 60 * 60 * 1000;

interface LocationContextType {
  locations: { label: string; value: string }[];
  rawData: MunicipioJson[];
}

const LocationContext = createContext<LocationContextType>({
  locations: [],
  rawData: [],
});

export function LocationProvider({ children }: { children: ReactNode }) {
  const [locations, setLocations] = useState<LocationContextType["locations"]>(
    [],
  );
  const [rawData, setRawData] = useState<MunicipioJson[]>([]);

  useEffect(() => {
    async function fetchMunicipios() {
      try {
        const cached = localStorage.getItem(CACHE_KEY);
        if (cached) {
          const { data, timestamp } = JSON.parse(cached);
          if (Date.now() - timestamp < CACHE_TTL_MS) {
            setRawData(data);
            setLocations(
              data.map((mun: MunicipioJson) => ({
                label: mun.mun_descricao,
                value: mun.mun_codigo,
              })),
            );
            return;
          }
        }

        const data = await jsonMunicipios();
        localStorage.setItem(
          CACHE_KEY,
          JSON.stringify({ data, timestamp: Date.now() }),
        );
        setRawData(data);
        setLocations(
          data.map((mun) => ({
            label: mun.mun_descricao,
            value: mun.mun_codigo,
          })),
        );
      } catch (error) {
        console.error("Erro ao buscar municípios:", error);
      }
    }

    fetchMunicipios();
  }, []);

  return (
    <LocationContext.Provider value={{ locations, rawData }}>
      {children}
    </LocationContext.Provider>
  );
}

export function useLocationContext() {
  return useContext(LocationContext);
}
